import { render, staticRenderFns } from "./Group.vue?vue&type=template&id=cb952d92&scoped=true&"
import script from "./Group.vue?vue&type=script&lang=js&"
export * from "./Group.vue?vue&type=script&lang=js&"
import style0 from "./Group.vue?vue&type=style&index=0&id=cb952d92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb952d92",
  null
  
)

export default component.exports